import { __assign, __rest } from "tslib";
import React from 'react';
import { Image, View } from 'react-native';
import { PnmacImage, PnmacNavigation, HomeCard } from 'pnmac-universal-components';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events';
import { getActiveFeatures } from '../../utils.js';
import { AmortizationCardPicker } from './AmortizationCardPicker';
import HappyHomeSVG from '../../assets/happy-home.svg';
import CalculatorsSVG from '../../assets/calculators.svg';
import EdibursmentsSVG from '../../assets/e-disbursements.svg';
export var ThirdPartyCards = function (_a) {
  var matches = _a.matches,
    enabled = _a.enabled,
    props = __rest(_a, ["matches", "enabled"]);
  var layout = props.layout,
    translations = props.translations,
    trackerDispatcher = props.trackerDispatcher;
  var iconSize = matches.small ? 40 : 65;
  return /*#__PURE__*/React.createElement(React.Fragment, null, layout.isCobranded && getActiveFeatures(layout.features, 'View_Subservicing_Tile') && (/*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "SubservicingBoxTile",
    title: translations.CobrandingBoxWelcomeToPennymacFamily,
    icon: function () {
      return PnmacImage(layout.mobile ? 'happyHome' : HappyHomeSVG, iconSize, 'Happy Home icon');
    },
    body: /*#__PURE__*/React.createElement(React.Fragment, null, layout.mobile ? (/*#__PURE__*/React.createElement(View, {
      style: {
        maxHeight: 120,
        paddingTop: 0
      }
    }, PnmacImage(layout.logoUrl, 250, 'logo'))) : (/*#__PURE__*/React.createElement(Image, {
      style: {
        height: 120,
        width: '100%'
      },
      resizeMode: "contain",
      source: {
        uri: layout.logoUrl
      }
    }))),
    small: matches.small
  })), /*#__PURE__*/React.createElement(AmortizationCardPicker, __assign({
    matches: matches,
    enabled: enabled
  }, props)), /*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "EscrowTile",
    title: translations.SubservicingTileEscrow,
    icon: function () {
      return PnmacImage(layout.mobile ? 'calculators' : CalculatorsSVG, iconSize, 'Calculators', 'css');
    },
    body: translations.SubservicingTileEscrowInformation,
    buttonText: translations.SubservicingTileEscrowCenter,
    buttonDisabled: !enabled,
    small: matches.small,
    onButtonPress: function () {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Escrow Center Tile Clicked', 0);
      PnmacNavigation(__assign({
        action: {
          pathname: "/Loan/Escrow"
        }
      }, props));
    }
  }), getActiveFeatures(layout.features, "PrivateLabel_DynamicTile", layout.whitelisted) && layout.isPrivateLabel && (/*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "PrivateLabel_DynamicTile",
    title: translations === null || translations === void 0 ? void 0 : translations.PLProductOffersHeader,
    icon: function () {
      return PnmacImage(layout.mobile ? 'eDisbursements' : EdibursmentsSVG, iconSize, 'Dollar sign', 'css');
    },
    body: translations === null || translations === void 0 ? void 0 : translations.PLProductOffersContent,
    buttonText: translations.PrivateLabelTile,
    buttonDisabled: !enabled,
    small: matches.small,
    onButtonPress: function () {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'PrivateLabel Tile Clicked', 0);
      PnmacNavigation(__assign({
        action: {
          pathname: "/Offers"
        }
      }, props));
    }
  })));
};